import { render, staticRenderFns } from "./RailwayPage.vue?vue&type=template&id=0da21172&"
import script from "./RailwayPage.vue?vue&type=script&lang=js&"
export * from "./RailwayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports